<template>
  <div class="filter--mobile">
    <div class="title-row">
      <h3>{{ "filter.title.filter" | translate }}</h3>
      <div class="icon-container" @click="onCloseClick()">
        <BIconX class="close-icon" />
      </div>
    </div>

    <search-bar
      class="search-bar"
      is-mobile
      :placeholder="'filter.title.search' | translate"
      v-model="searchString"
    ></search-bar>

    <sex-selector
      class="sex-selector"
      :is-navigation="false"
      :value="sex"
      @input="setSex($event)"
    />

    <!-- selects -->
    <div class="select-container mobile-filter">
      <div v-for="(filter, i) in determineSelects" :key="i" class="filter-item">
        <gyra-filter
          :filter="filter"
          :allow-text-input="false"
          @input="onFilterChanged()"
        />
      </div>
    </div>

    <p class="focus-title">{{ "filter.title.focus" | translate }}</p>
    <div class="toggle-row">
      <toggle
        class="toggle"
        emoji="sustainable"
        label="product_map.sustainable"
        @input="onToggleChange"
        v-model="sustainable"
      ></toggle>
      <toggle
        class="toggle"
        emoji="onSale"
        label="product_map.onSale"
        @input="onToggleChange"
        v-model="onSale"
      ></toggle>
    </div>

    <div class="btn-container">
      <div class="apply-button" @click="onApplyClick()">
        <p>{{ "filter.messages.apply" | translate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "../atoms/search-bar";
import { BIconX } from "bootstrap-vue";
import SexSelector from "../atoms/sex-selector";
import { filterMixin } from "../../mixins/filters/filterMixin";
import { filterModelMixin } from "../../mixins/filters/filterModelMixin";
import Toggle from "../atoms/toggle";
import GyraFilter from "./gyra-filter";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "filter-mobile",
  mixins: [filterMixin, filterModelMixin],
  components: { GyraFilter, Toggle, SexSelector, SearchBar, BIconX },
  props: {
    includeTypeSelect: { type: Boolean, default: false }
  },
  methods: {
    onCloseClick() {
      this.$emit("close");
    },
    setSex($event) {
      this.resetCommons();
      this.sex = $event === "general.women" ? "women" : "men";
      this.setSelectOptions();
    },
    onApplyClick() {
      this.$emit("apply");
    },
    onFilterChanged() {
      this.$emit("filterChanged");
    },
    onToggleChange() {
      this.setSelectOptions();
    },
    ...mapMutations({
      resetCommons: "filters/resetCommons"
    })
  },
  computed: {
    determineSelects() {
      return this.includeTypeSelect ? this.selectsIncludingType : this.selects;
    },
    ...mapGetters({
      selectsIncludingType: "filters/getSelectsWithTypeSelect",
      selects: "filters/getSelects"
    })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.filter--mobile {
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 20px;
    position: relative;
  }

  $filter-margins-left-right: 23px;

  .title-row {
    display: flex;
    margin-top: 10px;
    @media (min-height: 736px) {
      margin-top: 30px;
    }

    flex-direction: row;
    justify-content: center;

    h3 {
      display: none;
      @media (min-height: 736px) {
        display: flex;
      }
    }

    .close-icon {
      width: 24px;
      height: 24px;
    }

    .icon-container {
      position: absolute;
      right: -100px;
      top: 45px;
      @media (min-height: 736px) {
        right: -100px;
        top: 30px;
      }
      margin-right: 116px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .search-bar {
    height: 42.8px;
    margin: 20px 60px 0 $filter-margins-left-right;
    @media (min-height: 736px) {
      margin: 25px $filter-margins-left-right 0;
    }
  }

  .sex-selector {
    margin: 28px $filter-margins-left-right 0;
    @media (min-height: 736px) {
      margin: 33px $filter-margins-left-right 0;
    }
    height: 36px;
    width: 180px;
  }

  .focus-title {
    margin: 16px 0 0 $filter-margins-left-right;
    @media (min-height: 736px) {
      margin: 20px 0 0 $filter-margins-left-right;
    }
  }

  .toggle-row {
    width: 100%;
    margin-top: 23.5px $filter-margins-left-right 0;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .apply-button {
    margin-top: 22px;
    @media (min-height: 736px) {
      margin-top: 26px;
    }
    width: 140px;
    height: 45px;
    border-radius: 10px;
    box-shadow: 10px 10px 30px 0 rgba(0, 0, 0, 0.16);
    background-color: $gyra-grey-dark;
    display: flex;
    justify-content: center;
    cursor: pointer;

    p {
      color: white;
    }
  }

  .btn-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.filter-item--mobile {
  position: relative;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
}
.select-container {
  margin-top: 22px;
  @media (min-height: 736px) {
    margin-top: 30px;
  }
}

.filter-item {
  margin: 0 $gyra-margin-sides-mobile;
  border-bottom: 1px solid $gyra-grey-lightest;

  &:not(:first-child) {
    margin-top: 16px;
    @media (min-height: 736px) {
      margin-top: 20px;
    }
  }
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.filter-item--mobile {
  .vs__dropdown-toggle {
    border: none;
  }

  .dropdown-toggle {
    border: none;
  }
  .dropdown-toggle::after {
    content: "";
  }
}
</style>
